import api from './api';

export const getChannels = (page, params) => {
  return api.get('admin/Channel', { params: { page: page, limit: 5, ...params } });
};

export const updateChannel = (channelId, update) => {
  return api.put(`admin/Channel/item/${channelId}`, { object: update });
};

export const getChannelMetricsByPeriod = (uid, start, end) => {
  return api.get(`admin/channel/${uid}/metrics/start/${start}/end/${end}`);
};

export const getRecipientData = channelUid => {
  return api.get(`admin/channel/${channelUid}/recipient`);
};

export const setRecipientToManual = channelUid => {
  return api.put(`admin/channel/${channelUid}/change_withdraw_to_manual`);
};

export const sendCsv = (channelUid, file, channelSegmentedListId = false) => {
  const config = { headers: { 'content-type': 'multipart/form-data' } };
  return api.post(`admin/channel/${channelUid}/segmented-list/${channelSegmentedListId}/import_csv`, file, config);
};

export const getExport = (type, channelUid, startDate, endDate) => {
  return api.post(`admin/export`, { type, channelUid, startDate, endDate }, { responseType: 'blob' });
};

export const getChannelsWithoutAddress = page => {
  return api.get('admin/channels/withoutAddress', { params: { page: page } });
};

export const addAddressToChannel = (channelUid, address) => {
  return api.post(`admin/channel/${channelUid}/address`, { address });
};

export const getAddressInformation = channelId => {
  return api.get(`admin/channel/${channelId}/address`);
};

export const getEmailTemplateStyles = channelUid => {
  return api.get(`admin/channel/${channelUid}/emailTemplateStyles`);
};

export const addNewEmailTemplateStyle = channelUid => {
  return api.post(`admin/channel/${channelUid}/emailTemplateStyles`);
};

export const getEmailTemplateStyleById = id => {
  return api.get(`admin/channel/emailTemplateStyle/${id}`);
};

export const updateEmailTemplateStyle = (id, emailTemplate) => {
  return api.put(`admin/channel/emailTemplateStyle/${id}`, { emailTemplate });
};

export const deleteEmailTemplateStyle = id => {
  return api.delete(`admin/channel/emailTemplateStyle/${id}`);
};

export const getChannelSegmentedLists = channelUid => {
  return api.get('admin/ChannelSegmentedList', { params: { page: 0, limit: 50, searchItem: 'channelUid', search: channelUid } });
};

export const getChannelInfos = channelUid => {
  return api.get(`/admin/channel/${channelUid}/info`);
};

export const getChannelMembersByUid = channelUid => {
  return api.get(`/admin/channel/${channelUid}/channel-members`);
};
